import React, { FC } from 'react';
import AccordionWidgetIcon from 'app/modules/posts/components/accordionWidget/AccordionWidgetIcon';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import AccordionWidgetTitle from 'app/modules/posts/components/accordionWidget/AccordionWidgetTitle';
import Skeleton from 'react-loading-skeleton';
import ErrorLoadingDetailProperty from 'components/shared/detail/ErrorLoadingDetailProperty';
import AccordionWidgetEmptyMessage from 'app/modules/posts/components/accordionWidget/AccordionWidgetEmptyMessage';
import { Chip } from '@kontentino/ui';
import NumberUtil from 'utils/number';
import { usePostQuery } from 'app/modules/posts/modules/post/hooks/usePostQuery';
import { useCurrencies } from 'modules/listings/listingsSelectors';

type Props = {
  id: number;
  accordionProps?: Partial<React.ComponentProps<typeof AccordionWidget>>;
};

const BoostBudget: FC<Props> = (props) => {
  const { postDetail } = usePostQuery(props.id);
  const currencies = useCurrencies();

  return (
    <AccordionWidget
      icon={<AccordionWidgetIcon variant="boostBudget" />}
      title={<AccordionWidgetTitle variant="boostBudget" />}
      titleSuffix={(isOpen) =>
        !isOpen &&
        !!postDetail.data?.budget && (
          <Chip variant="darkGrey">
            {NumberUtil.compact(Number(postDetail.data.budget))}{' '}
            {currencies.list[postDetail.data.budget_currency]}
          </Chip>
        )
      }
      {...props.accordionProps}
    >
      <>
        {postDetail.isLoading && <Skeleton height={60} />}
        {postDetail.isError && <ErrorLoadingDetailProperty />}
        {!!postDetail.data?.budget && (
          <p
            data-cy="post-detail-budget-value"
            className="tw-text-base tw-font-semibold"
          >
            {NumberUtil.compact(Number(postDetail.data.budget))}{' '}
            {currencies.list[postDetail.data.budget_currency]}
          </p>
        )}
        {!postDetail.data?.budget &&
          !postDetail.isLoading &&
          !postDetail.isError && (
            <AccordionWidgetEmptyMessage variant="boostBudget" />
          )}
      </>
    </AccordionWidget>
  );
};

export default BoostBudget;
